import HttpRequest from "../request";
import type { BusinessPriceConfigResponse, EnterpriseTradeOrder } from "./types";
import { ProApi } from "../api";
import type { Response } from "../request";

export default {
    getRequestProConfig(): Promise<Response<BusinessPriceConfigResponse>> {
        return HttpRequest.get(ProApi.getProConfig, null)
    },
    getRequestBuyTranslateTrade(param: any): Promise<Response<any>> {
        return HttpRequest.post(ProApi.getBuyTranslateTrade, param)
    },
    getTradeOrder(orderNo: string): Promise<Response<EnterpriseTradeOrder>> {
        return HttpRequest.get(ProApi.getTradeOrder, { orderNo })
    },
    getRequestStripePayStatus(param: any): Promise<Response<any>> {
        return HttpRequest.get(ProApi.getStripePayStatus, param)
    },
    getRequestCheckPayPalStatus(param: any): Promise<Response<any>> {
        return HttpRequest.get(ProApi.getCheckPayPalStatus, param)
    }
}
